import { TileIds, TileRules } from '../../../../util/tileEnums';
import { CignaModalValue } from '../../../components/InsuranceHelpModal/modalValues';
import { InsurerCodes } from '../../../../../../../constants/insurance';

export const cignaInsightTiles = [
  {
    id: TileIds.INSURANCE_INSIGHT_FLU_SHOT,
    header: 'Free Flu Shots',
    description: () => `Get your annual flu shot at select locations`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.FLU_SHOT,
    sortOrder: { [InsurerCodes.CIGNA]: 8 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GYM_MEMBERSHIP,
    header: 'Work It Out',
    description: () => `10% off select gym memberships`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.GYM_MEMBERSHIP,
    sortOrder: { [InsurerCodes.CIGNA]: 1 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_THERAPEUTIC_MASSAGE,
    header: 'Loosen Up',
    description: () => `Discounts on select massage therapists`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.THERAPEUTIC_MASSAGE,
    sortOrder: { [InsurerCodes.CIGNA]: 6 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_CHIROPRACTOR,
    header: 'Get Aligned',
    description: () => `Discount on select chiropractors`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.CHIROPRACTOR,
    sortOrder: { [InsurerCodes.CIGNA]: 11 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_PHYSICAL_THERAPY,
    header: 'Repair, Protect, Recover',
    description: () => `25% off select physical therapy`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.PHYSICAL_THERAPY,
    sortOrder: { [InsurerCodes.CIGNA]: 12 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_JENNY_CRAIG,
    header: 'Get Healthy',
    description: () => `30% off at Jenny Craig`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.JENNY_CRAIG,
    sortOrder: { [InsurerCodes.CIGNA]: 5 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GAIAM_YOGA,
    header: 'Namaste',
    description: () => `25% off Gaiam Yoga`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.GAIAM_YOGA,
    sortOrder: { [InsurerCodes.CIGNA]: 9 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_ACUPUNCTURE,
    header: 'Stick It To Me',
    description: () => `Discounts on select acupuncturists`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.ACUPUNCTURE,
    sortOrder: { [InsurerCodes.CIGNA]: 16 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_GLASSES,
    header: 'Let There Be Sight',
    description: () => `25% off glasses at select providers`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.GLASSES,
    sortOrder: { [InsurerCodes.CIGNA]: 3 },
  },
  {
    id: TileIds.INSURANCE_INSIGHT_LASIK,
    header: 'See Things Clearly',
    description: () => `Up to 15% off LASIK booked through US Laser Network`,
    rules: [TileRules.IS_INSURANCE_CIGNA, TileRules.IS_NOT_CHILD],
    modalValue: CignaModalValue.LASIK,
    sortOrder: { [InsurerCodes.CIGNA]: 13 },
  },
];
